import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ExamDetailsFragment = { __typename?: 'Exam', id: string, name: string, date: string, duration?: number | null, medium?: string | null, typ?: string | null, has_scrambling_b?: boolean | null, number_of_additional_scramblings?: number | null, locked_at_date?: string | null, de: boolean, en: boolean, fr: boolean, it: boolean, show_first_dimension_presort?: boolean | null, allow_question_comments?: boolean | null, first_presort_criterion?: boolean | null, second_presort_criterion?: boolean | null, third_presort_criterion?: boolean | null, locked: boolean, self_assessed: boolean, is_in_the_future: boolean, provisioned: boolean, examinator_unlock_token?: string | null, content: { __typename?: 'TranslatedContent', de?: string | null, en?: string | null, fr?: string | null, it?: string | null }, presort_criteria: Array<{ __typename?: 'PresortCriteria', type?: string | null, name?: string | null, position?: number | null }> };

export type LoadExamDetailsQueryVariables = Types.Exact<{
  examId: Types.Scalars['ID'];
}>;


export type LoadExamDetailsQuery = { __typename?: 'Query', exam: { __typename?: 'Exam', id: string, name: string, date: string, duration?: number | null, medium?: string | null, typ?: string | null, has_scrambling_b?: boolean | null, number_of_additional_scramblings?: number | null, locked_at_date?: string | null, de: boolean, en: boolean, fr: boolean, it: boolean, show_first_dimension_presort?: boolean | null, allow_question_comments?: boolean | null, first_presort_criterion?: boolean | null, second_presort_criterion?: boolean | null, third_presort_criterion?: boolean | null, locked: boolean, self_assessed: boolean, is_in_the_future: boolean, provisioned: boolean, examinator_unlock_token?: string | null, content: { __typename?: 'TranslatedContent', de?: string | null, en?: string | null, fr?: string | null, it?: string | null }, presort_criteria: Array<{ __typename?: 'PresortCriteria', type?: string | null, name?: string | null, position?: number | null }> } };

export const ExamDetailsFragmentDoc = gql`
    fragment ExamDetails on Exam {
  id
  name
  content {
    de
    en
    fr
    it
  }
  date
  duration
  medium
  typ
  has_scrambling_b
  number_of_additional_scramblings
  locked_at_date
  de
  en
  fr
  it
  show_first_dimension_presort
  allow_question_comments
  first_presort_criterion
  second_presort_criterion
  third_presort_criterion
  presort_criteria {
    type
    name
    position
  }
  locked
  self_assessed
  is_in_the_future
  provisioned
  examinator_unlock_token
}
    `;
export const LoadExamDetailsDocument = gql`
    query LoadExamDetails($examId: ID!) {
  exam(id: $examId) {
    ...ExamDetails
  }
}
    ${ExamDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadExamDetailsGQL extends Apollo.Query<LoadExamDetailsQuery, LoadExamDetailsQueryVariables> {
    document = LoadExamDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }